import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const CUSTOMERS_REQUESTS = gql`
  query GetCustomers {
    customers(limit: 100, offset: 0) {
      data {
        codigo
        status
        dataCadastro 
        razaoSocial
        nomeFantasia
        cpfCnpj
        endereco
        numero
        cep
        bairro
        cidade
        estado
        pais
        telefone
        celular
        email
      }
      totalRecords
    }
  }
`;

export const getAllCustomers = async () => {
    
        const response = await queryAllPages(client, {
            query: CUSTOMERS_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.customers;
        return data;
    
}